import * as t from 'io-ts'

export const TransitionFeatureDecoder = t.partial(
  {
    enabled: t.boolean,
    isDefaultView: t.boolean,
  },
  'TransitionFeature'
)

export type TransitionFeature = t.TypeOf<typeof TransitionFeatureDecoder>
